import {
  AutoCompleteField,
  CheckboxField,
  DatePickerField,
  InputField,
  MultiSelectField,
  SelectField,
  Text,
} from '@profitowi/component-library';

import useDictionaryOptions from 'hooks/useDictionaryOptions';
import { useMemo, useState } from 'react';
import { createAgentsOptions } from 'helpers/agents';
import { useAgentQuery } from 'hooks/useAgentQuery';
import { InputType, ParamType, Params } from 'types/reports';

type Props = {
  configParams: Params;
};

const Select = ({ configParams }: Props) => {
  const { paramKey, fieldName, paramType, inputType } = configParams;
  const dictionaryOptions = useDictionaryOptions(paramType);

  const options =
    paramKey === 'BONUS_CODE'
      ? dictionaryOptions.map((option) => ({
          ...option,
          value: option.key,
        }))
      : dictionaryOptions;

  return (
    <>
      {inputType === InputType.DICTIONARY_SELECT && (
        <SelectField name={paramKey} label={fieldName} options={options} />
      )}

      {inputType === InputType.DICTIONARY_MULTISELECT && (
        <MultiSelectField name={paramKey} label={fieldName} options={options} />
      )}
    </>
  );
};

const AgentField = ({ configParams }: Props) => {
  const { paramKey, fieldName } = configParams;
  const [query, setQuery] = useState('');
  const { data: searchAgents } = useAgentQuery({ queryParam: query, minQueryLength: 3 });

  const options = useMemo(
    () => (searchAgents ? createAgentsOptions(searchAgents.content, 'id') : [{ key: 0, value: '' }]),
    [searchAgents]
  );

  return (
    <div className="w-full">
      <Text className="text-secondary">{fieldName}</Text>
      <AutoCompleteField
        placeholder="Wyszukaj agenta"
        name={paramKey}
        options={options}
        query={query}
        setQuery={setQuery}
      />
    </div>
  );
};

const DynamicField = ({ configParams }: Props) => {
  const { paramKey, fieldName, paramType, mandatory } = configParams;

  // Handle special input types first
  if ((configParams as any).inputType === InputType.AGENT) {
    return <AgentField configParams={configParams} />;
  }

  switch (paramType) {
    case ParamType.BOOLEAN:
      return (
        <CheckboxField name={paramKey} isRequired={mandatory}>
          {fieldName}
        </CheckboxField>
      );
    case ParamType.DATE:
      return <DatePickerField preventOpenOnFocus label={fieldName} name={paramKey} />;
    case ParamType.STRING:
      return <InputField name={paramKey} label={fieldName} isRequired={mandatory} />;
    default:
      return <Select configParams={configParams} />;
  }
};

export default DynamicField;
